// extracted by mini-css-extract-plugin
export var menuIcon = "_q8-0";
export var menuIconInline = "_q8-1";